import { Observable, catchError, delay, of, tap } from 'rxjs';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { Component, Input, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { AuthService } from '@core/modules/authentication/services/auth.service';

@Component({
    selector: 'app-verifying-email',
    templateUrl: './verifying-email.component.html',
    styleUrls: ['./verifying-email.component.scss'],
    standalone: false
})
export class VerifyingEmailComponent implements OnChanges {
  @Input() email: string = '';

  resendActivationAccountLink$: Observable<any> = of();

  isCompleteResendActivationLink = false;

  get howActivateParams() {
    return {
      email: this.email
    };
  }

  constructor(
    private messageService: MessageService,
    private authService: AuthService,
    private translateService: TranslateService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    const currentEmail: SimpleChange = changes.email;
    if (currentEmail.isFirstChange()) {
      this.resendActivationAccountLink$ = this.sendActivationAccountLink(currentEmail.currentValue);
    }
  }

  onResendActivationLink(event: Event) {
    event.preventDefault();
    this.resendActivationAccountLink(this.email);
  }

  private sendActivationAccountLink(email: string): Observable<any> {
    return this.authService.resendActivationLink(email).pipe(
      catchError((error) => {
        console.error('[VERIFYING:EMAIL] Error resend activation link: ', error);
        return of('error');
      })
    );
  }

  private resendActivationAccountLink(email: string): void {
    this.isCompleteResendActivationLink = false;

    this.resendActivationAccountLink$ = this.sendActivationAccountLink(email).pipe(
      tap(() =>
        this.messageService.add({
          severity: 'success',
          detail: this.translateService.instant('verifying-email.resend-verifying-email.success')
        })
      ),
      tap(() => {
        this.isCompleteResendActivationLink = true;
      }),
      delay(3000),
      tap(() => {
        this.isCompleteResendActivationLink = false;
      })
    );
  }
}
